import { render, staticRenderFns } from "./SingleBooking.vue?vue&type=template&id=cc04d8e6&scoped=true"
import script from "./SingleBooking.vue?vue&type=script&lang=js"
export * from "./SingleBooking.vue?vue&type=script&lang=js"
import style0 from "./SingleBooking.vue?vue&type=style&index=0&id=cc04d8e6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc04d8e6",
  null
  
)

export default component.exports